import { render, staticRenderFns } from "./ProjectUsers.vue?vue&type=template&id=bea6ba12&lang=true&"
import script from "./ProjectUsers.vue?vue&type=script&lang=js&"
export * from "./ProjectUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports